import { startTransition, StrictMode } from 'react';

import * as Sentry from '@sentry/react-router';
import { hydrateRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { HydratedRouter } from 'react-router/dom';

import { appEnv } from '@/shared/configs/app.config';
import { createI18nClientInstance, i18n } from '@/shared/configs/i18n.config';
import { getLocaleFromPathname } from '@/shared/utils/i18n.utils';

Sentry.init({
  dsn: appEnv.VITE_PUBLIC_SENTRY_DSN,
  enabled: import.meta.env.MODE === 'production',
  debug: false,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.reactRouterTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
});

async function hydrate() {
  const locale = getLocaleFromPathname(window.location.pathname);
  await createI18nClientInstance(locale);

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <I18nextProvider i18n={i18n}>
          <HydratedRouter />
        </I18nextProvider>
      </StrictMode>,
    );
  });
}

hydrate();
